import React, { Component } from 'react';
import { flowRight as compose } from 'lodash';
import { withQuery, withMutation } from '../../../hoc/withGraphql';
import getProspects from './getProspects.graphql';
import saveProspectM from './saveProspect.graphql';
import deleteProspectM from './deleteProspect.graphql';
import bulkImportM from './bulkImportProspects.graphql';
import sendEmailM from './sendProspectingEmail.graphql';

const RED = '#D32F2F';
const INK = '#1F2733';
const GREY = '#6B7280';
const PAGE = 20;
const CATS = { client: ['company', 'individual'], worker: ['small-jobs', 'large-projects'] };
const th = { textAlign: 'left', padding: '8px 10px', borderBottom: '1px solid #eee', fontSize: 12, color: GREY };
const td = { padding: '8px 10px', borderBottom: '1px solid #f4f4f4', fontSize: 13, verticalAlign: 'top' };
const inp = { padding: '8px 10px', border: '1px solid #ddd', borderRadius: 8, fontSize: 13, margin: '0 6px 8px 0' };
const btn = (bg) => ({ background: bg, color: '#fff', border: 'none', borderRadius: 8, padding: '8px 14px', fontWeight: 600, cursor: 'pointer', fontSize: 13 });

class Prospecting extends Component {
  state = { page: 1, form: {}, editId: null, importData: '', importCat: '', subject: '', message: '', emailStatusFilter: 'new', busy: false, msg: '' };

  get type() { return this.props.type === 'worker' ? 'worker' : 'client'; }

  refetch = () => this.props.prospects.refetch({ type: this.type, currentPage: this.state.page });

  setF = (k, v) => this.setState((s) => ({ form: { ...s.form, [k]: v } }));

  save = async () => {
    this.setState({ busy: true, msg: '' });
    const f = this.state.form;
    const res = await this.props.saveMut({ variables: { id: this.state.editId ? parseInt(this.state.editId, 10) : null, type: this.type, ...f } });
    const r = res && res.data && res.data.saveProspect;
    this.setState({ busy: false, msg: r && r.status === 200 ? '✅ Saved.' : ((r && r.errorMessage) || 'Error.'), form: r && r.status === 200 ? {} : f, editId: r && r.status === 200 ? null : this.state.editId });
    if (r && r.status === 200) this.refetch();
  };

  edit = (p) => this.setState({ editId: p.id, form: { category: p.category, companyName: p.companyName, contactName: p.contactName, email: p.email, phone: p.phone, city: p.city, state: p.state, source: p.source, notes: p.notes } });

  del = async (id) => { if (typeof window !== 'undefined' && !window.confirm('Delete this prospect?')) return; await this.props.delMut({ variables: { id } }); this.refetch(); };

  changeStatus = async (p, status) => { await this.props.saveMut({ variables: { id: p.id, status } }); this.refetch(); };

  runImport = async () => {
    this.setState({ busy: true, msg: '' });
    const res = await this.props.importMut({ variables: { type: this.type, category: this.state.importCat || null, data: this.state.importData } });
    const r = res && res.data && res.data.bulkImportProspects;
    this.setState({ busy: false, msg: r && r.status === 200 ? `✅ Imported ${r.imported}, skipped ${r.skipped}.` : ((r && r.errorMessage) || 'Error.'), importData: r && r.status === 200 ? '' : this.state.importData });
    if (r && r.status === 200) this.refetch();
  };

  sendEmail = async () => {
    if (typeof window !== 'undefined' && !window.confirm(`Send this email to ${this.type}s with status "${this.state.emailStatusFilter || 'new+contacted'}"?`)) return;
    this.setState({ busy: true, msg: '' });
    const res = await this.props.emailMut({ variables: { type: this.type, statusFilter: this.state.emailStatusFilter || null, subject: this.state.subject, message: this.state.message } });
    const r = res && res.data && res.data.sendProspectingEmail;
    this.setState({ busy: false, msg: r && r.status === 200 ? `✅ Sent ${r.sent} emails (${r.failed} failed).` : ((r && r.errorMessage) || 'Error.') });
    if (r && r.status === 200) this.refetch();
  };

  goPage = (d) => this.setState((s) => ({ page: Math.max(1, s.page + d) }), this.refetch);

  render() {
    const data = (this.props.prospects && this.props.prospects.getProspects) || {};
    const rows = data.results || [];
    const f = this.state.form;
    const cats = CATS[this.type];
    const pages = Math.max(1, Math.ceil((data.count || 0) / PAGE));
    return (
      <div style={{ padding: 20, maxWidth: 1100 }}>
        <h1 className="siteAdminPrimaryHeading">{this.type === 'worker' ? 'Potential Workers' : 'Potential Clients'}</h1>
        <div style={{ margin: '8px 0 14px', color: GREY, fontSize: 13 }}>
          Total {data.count || 0} · New {data.newCount || 0} · Contacted {data.contactedCount || 0} · Replied {data.repliedCount || 0} · Converted {data.convertedCount || 0}
        </div>
        {this.state.msg ? <div style={{ margin: '8px 0', fontWeight: 600 }}>{this.state.msg}</div> : null}

        <div style={{ background: '#fff', border: '1px solid #eee', borderRadius: 12, padding: 16, marginBottom: 16 }}>
          <div style={{ fontWeight: 700, marginBottom: 10 }}>{this.state.editId ? 'Edit prospect' : 'Add a prospect'}</div>
          <input style={inp} placeholder="Company name" value={f.companyName || ''} onChange={(e) => this.setF('companyName', e.target.value)} />
          <input style={inp} placeholder="Contact name" value={f.contactName || ''} onChange={(e) => this.setF('contactName', e.target.value)} />
          <input style={inp} placeholder="Email" value={f.email || ''} onChange={(e) => this.setF('email', e.target.value)} />
          <input style={inp} placeholder="Phone" value={f.phone || ''} onChange={(e) => this.setF('phone', e.target.value)} />
          <input style={inp} placeholder="City" value={f.city || ''} onChange={(e) => this.setF('city', e.target.value)} />
          <input style={{ ...inp, width: 70 }} placeholder="State" value={f.state || ''} onChange={(e) => this.setF('state', e.target.value)} />
          <select style={inp} value={f.category || ''} onChange={(e) => this.setF('category', e.target.value)}>
            <option value="">Category…</option>
            {cats.map((c) => <option key={c} value={c}>{c}</option>)}
          </select>
          <input style={inp} placeholder="Source" value={f.source || ''} onChange={(e) => this.setF('source', e.target.value)} />
          <button style={btn(RED)} disabled={this.state.busy} onClick={this.save}>{this.state.editId ? 'Update' : 'Add'}</button>
          {this.state.editId ? <button style={{ ...btn('#888'), marginLeft: 8 }} onClick={() => this.setState({ editId: null, form: {} })}>Cancel</button> : null}
        </div>

        <div style={{ background: '#fff', border: '1px solid #eee', borderRadius: 12, padding: 16, marginBottom: 16 }}>
          <div style={{ fontWeight: 700, marginBottom: 6 }}>Bulk import</div>
          <div style={{ color: GREY, fontSize: 12, marginBottom: 8 }}>One per line: companyName, contactName, email, phone, city, state (comma or tab separated). Duplicates by email are skipped.</div>
          <select style={inp} value={this.state.importCat} onChange={(e) => this.setState({ importCat: e.target.value })}><option value="">Category…</option>{cats.map((c) => <option key={c} value={c}>{c}</option>)}</select>
          <textarea style={{ width: '100%', height: 90, padding: 10, border: '1px solid #ddd', borderRadius: 8, fontSize: 13 }} placeholder="Acme Property Mgmt, John Doe, john@acme.com, 2155551234, Philadelphia, PA" value={this.state.importData} onChange={(e) => this.setState({ importData: e.target.value })} />
          <div style={{ marginTop: 8 }}><button style={btn(INK)} disabled={this.state.busy} onClick={this.runImport}>Import</button></div>
        </div>

        <div style={{ background: '#fff', border: '1px solid #eee', borderRadius: 12, padding: 16, marginBottom: 16 }}>
          <div style={{ fontWeight: 700, marginBottom: 6 }}>Send prospecting email</div>
          <div style={{ color: GREY, fontSize: 12, marginBottom: 8 }}>Placeholders: {'{name} {company} {city} {state}'}. CAN-SPAM compliant (unsubscribe + address added automatically).</div>
          <span style={{ fontSize: 13, marginRight: 6 }}>To status:</span>
          <select style={inp} value={this.state.emailStatusFilter} onChange={(e) => this.setState({ emailStatusFilter: e.target.value })}>
            <option value="new">new (not contacted)</option><option value="contacted">contacted</option><option value="">all (new + contacted)</option>
          </select>
          <input style={{ ...inp, width: '55%' }} placeholder="Subject" value={this.state.subject} onChange={(e) => this.setState({ subject: e.target.value })} />
          <textarea style={{ width: '100%', height: 120, padding: 10, border: '1px solid #ddd', borderRadius: 8, fontSize: 13 }} placeholder={'Hi {name},\n\nWe help property managers in {city} get vetted pros on demand...'} value={this.state.message} onChange={(e) => this.setState({ message: e.target.value })} />
          <div style={{ marginTop: 8 }}><button style={btn(RED)} disabled={this.state.busy} onClick={this.sendEmail}>Send email →</button></div>
        </div>

        <div style={{ background: '#fff', border: '1px solid #eee', borderRadius: 12, overflow: 'hidden' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead><tr style={{ background: '#fafafa' }}><th style={th}>Company / Contact</th><th style={th}>Email / Phone</th><th style={th}>City / State</th><th style={th}>Category</th><th style={th}>Status</th><th style={th}>Sent</th><th style={th} /></tr></thead>
            <tbody>
              {rows.length === 0 && <tr><td style={td} colSpan={7}>No prospects yet — add or import some above.</td></tr>}
              {rows.map((p) => (
                <tr key={p.id}>
                  <td style={td}><b>{p.companyName || '—'}</b><div style={{ color: GREY }}>{p.contactName || ''}</div></td>
                  <td style={td}>{p.email || '—'}<div style={{ color: GREY }}>{p.phone || ''}</div></td>
                  <td style={td}>{[p.city, p.state].filter(Boolean).join(', ') || '—'}</td>
                  <td style={td}>{p.category || '—'}</td>
                  <td style={td}>
                    <select value={p.status} onChange={(e) => this.changeStatus(p, e.target.value)} style={{ padding: 4, borderRadius: 6 }}>
                      {['new', 'contacted', 'replied', 'converted', 'dead'].map((s) => <option key={s} value={s}>{s}</option>)}
                    </select>
                  </td>
                  <td style={td}>{p.contactCount || 0}</td>
                  <td style={td}><button style={{ ...btn('#555'), padding: '4px 8px' }} onClick={() => this.edit(p)}>Edit</button> <button style={{ ...btn('#B00'), padding: '4px 8px' }} onClick={() => this.del(p.id)}>Del</button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {(data.count || 0) > PAGE ? (
          <div style={{ marginTop: 14, display: 'flex', gap: 12, alignItems: 'center' }}>
            <button style={btn(RED)} disabled={this.state.page <= 1} onClick={() => this.goPage(-1)}>Prev</button>
            <span>Page {this.state.page} / {pages}</span>
            <button style={btn(RED)} disabled={this.state.page >= pages} onClick={() => this.goPage(1)}>Next</button>
          </div>
        ) : null}
      </div>
    );
  }
}

export default compose(
  withQuery(getProspects, { name: 'prospects', options: (props) => ({ variables: { type: props.type === 'worker' ? 'worker' : 'client', currentPage: 1 }, fetchPolicy: 'network-only', ssr: false }) }),
  withMutation(saveProspectM, { name: 'saveMut' }),
  withMutation(deleteProspectM, { name: 'delMut' }),
  withMutation(bulkImportM, { name: 'importMut' }),
  withMutation(sendEmailM, { name: 'emailMut' }),
)(Prospecting);
